import { createFileRoute } from '@tanstack/react-router';
import EditUserPageComponent from 'src/Administration/EditUserPage/EditUserPage';

export const Route = createFileRoute('/systemadmin/_layout/users/edit/$id')({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  return <EditUserPageComponent id={id} />;
}
